import {
  Box,
  IconButton,
  ListItemButton,
  ListItemText,
  Tooltip,
  Typography,
} from '@mui/material';
import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { markNotificationRead } from '../../modules/notification';
import { Circle } from '@mui/icons-material';
import { getTimeElapsed } from '../../lib/notificationUtils';

const NotificationLine = ({ line }) => {
  const urlRegex = /(https?:\/\/[^\s,]+)/g;
  const parts = line.split(urlRegex);

  return (
    <>
      {parts.map((part, i) => {
        if (!/(https?:\/\/[^\s,]+)/.test(part)) return part;

        const isInternal =
          part.startsWith(window.location.origin) ||
          part.startsWith('http://localhost');

        if (isInternal) {
          const path = part
            .replace(window.location.origin, '')
            .replace(/^http:\/\/localhost:\d+/, '');
          const label = path.split('/').pop();

          return (
            <Link
              key={i}
              to={path}
              style={{ color: 'inherit' }}
              onClick={(e) => e.stopPropagation()}
            >
              {label}
            </Link>
          );
        }

        return (
          <a
            key={i}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'inherit'}}
            onClick={(e) => e.stopPropagation()}
          >
            {part}
          </a>
        );
      })}
    </>
  );
};
const NotificationBody = ({ body }) => {
  const lines = body.split('\n');

  return (
    <>
      {lines.map((line, i) => (
        <span key={i} style={{ display: 'block' }}>
          <NotificationLine line={line} />
        </span>
      ))}
    </>
  );
};

const NotificationItem = ({ notification, fetchNotifications }) => {
  const navigate = useNavigate();

  const handleNavigation = async (event) => {
    event.stopPropagation();
    if (notification.entity_link) {
      try {
        if (notification.status === 'unread') {
          await markNotificationRead(notification.id);
          await fetchNotifications();
        }

        const isFullUrl = notification.entity_link.startsWith('http');
        if (isFullUrl) {
          const url = new URL(notification.entity_link);
          navigate(url.pathname + url.search + url.hash);
        } else {
          navigate(notification.entity_link);
        }
      } catch (error) {
        console.error('Error marking notification as read:', error);
      }
    }
  };

  return (
    <Box sx={{borderBottom: '1px solid #ddd'}}>
      <ListItemButton
        onClick={(e) => handleNavigation(e)}
        sx={{
          px: 2,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          ...(notification.status === 'unread' && {
            bgcolor: 'action.hover',
            fontWeight: 'bold',
          }),
        }}>
        <ListItemText>
          <Typography
            variant="body2"
            sx={{ fontWeight: 'medium', textTransform: 'none' }}>
            {notification.title}
          </Typography>
          <Typography
            component="div"
            variant="body2"
            color="text.secondary"
            sx={{ mt: 0.5, textTransform: 'none' }}>
            <NotificationBody body={notification.body} />
            <Typography
              variant="caption"
              color="text.disabled"
              sx={{ display: 'block', mt: 0.5 }}>
              {getTimeElapsed(notification.created_at)}
            </Typography>
          </Typography>
        </ListItemText>

        {notification.status === 'unread' && (
          <Tooltip title="Mark as read" arrow>
            <IconButton onClick={handleNavigation} size="small">
              <Circle color="primary" sx={{ fontSize: 16 }} />
            </IconButton>
          </Tooltip>
        )}
      </ListItemButton>
    </Box>
  );
};

export default NotificationItem;
